import { Loading, Pullout, PulloutType } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { ICustomQuestionDimensionViewModel, IValidationResult, QuestionType, ResponseOptionGroupViewModel } from '../../../models';
import { ColFull, LoadingWrapper, Section } from '../../common';
import { ResponseOptionGroupRadioList } from './';

export interface IResponseOptionsSelectorProps {
	loading: boolean;
	questionId?: number;
	originalQuestionSourceReponseOptionGroupId?: number;
	questionDimensions: ICustomQuestionDimensionViewModel[];
	questionType: QuestionType;
	sourceResponseOptionGroupId?: number;
	libraryResponseOptionGroups: ResponseOptionGroupViewModel[];
	sectionContainer?: any;
	validationResult?: IValidationResult;
	HandleSetOpenEnded: () => void;
	HandleSetTextBox: () => void;
	HandleResponseOptionGroupChange: (responseOptionGroupId: number) => void;
}

export const ResponseOptionsWrapper = styled('div').attrs<{}>({
	className: 'tws-custom-response-options-selector',
})`
	margin: 40px 0;
`;

export class ResponseOptionsSelector extends React.Component<IResponseOptionsSelectorProps> {
	public render() {
		const {
			validationResult,
			libraryResponseOptionGroups,
			loading,
			questionId,
			questionType,
			originalQuestionSourceReponseOptionGroupId,
			questionDimensions,
			sectionContainer,
			sourceResponseOptionGroupId,
		} = this.props;
		const hasScoredDimensions = questionDimensions && questionDimensions.some((d) => d.isScored);

		const errors = validationResult ? validationResult.errors || [] : [];
		const Container = sectionContainer ? sectionContainer : Section;

		return (
			<Container id='choose-custom-responseoptions' sectionHeader={ContentConstants.SECTIONHEADERS_CUSTOM_QUESTION_CHOOSE_RESPONSEOPTION}>
				<ColFull>
					{ContentConstants.INSTRUCTIONALTEXT_CUSTOMQUESTION_CHOOSE_RESPONSEOPTION}{' '}
					<strong>{ContentConstants.INSTRUCTIONALTEXT_CUSTOMQUESTION_RESPONSEOPTION_CHANGE_TYPE}</strong>
				</ColFull>
				{loading && (
					<LoadingWrapper>
						<Loading height={'70px'} width={'70px'} />
					</LoadingWrapper>
				)}
				{!loading && (
					<>
						{questionId !== undefined && hasScoredDimensions && originalQuestionSourceReponseOptionGroupId !== sourceResponseOptionGroupId && (
							<Pullout type={PulloutType.Warning}>
								<strong>{ContentConstants.WARNING.toUpperCase() + ': '}</strong>
								{ContentConstants.INSTRUCTIONALTEXT_CUSTOMQUESTION_RESPONSEOPTION_CHANGE_WARNING}
							</Pullout>
						)}
						<ResponseOptionsWrapper>
							<ResponseOptionGroupRadioList
								questionType={questionType}
								selected={sourceResponseOptionGroupId}
								responseOptionGroups={libraryResponseOptionGroups}
								onChange={this.props.HandleResponseOptionGroupChange}
								setOpenEnded={this.props.HandleSetOpenEnded}
								setTextBox={this.props.HandleSetTextBox}
								hasBeenSaved={false}
								errorMsg={errors[0]}
							/>
						</ResponseOptionsWrapper>
					</>
				)}
			</Container>
		);
	}
}
